export const ERROR_STATUS = 'error';
export const LOADING_STATUS = 'loading';
export const SUCCESS_STATUS = 'success';
